import { ValidationError } from "@/domains/errors/kinds/ValidationError";

export class CoercionError extends ValidationError {
  constructor({ message, originalError }: { message: string; originalError?: Error }) {
    super({ message, originalError });
  }
}
